
<view-linkable :content-element="contentElement" :entry="entry">
  <img v-bind:height="imgHeight" :src="imgSrc" :alt="imgAlt" :class="classes">
</view-linkable>
